<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-8">
        <vx-card>
          <vs-input
            icon="icon-search"
            icon-pack="feather"
            class="w-full input-rounded-full no-icon-border"
            placeholder="Digite uma palavra para pesquisar"
            v-model="searchQuery"
          />
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2 mb-8" v-show="!videosList.length && searchQuery">
        Nenhum vídeo encontrado com o termo <strong>{{ searchQuery }}</strong>.
      </div>
      <div class="vx-col w-full md:w-1/2 mb-8" v-for="video in videosList" :key="video.id">
        <vx-card>
          <h4 class="p-2 pb-4">{{ video.title }}</h4>
          <iframe class="embed-responsive-item" width="100%" height="340" :src="`https://www.youtube.com/embed/${video.url}`" :title="video.title" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: '',
      videos: []
    }
  },
  computed: {
    videosList() {
      return this.videos.filter(
        (item) =>
          item.title.toLowerCase().includes(this.searchQuery.toLowerCase())
      ).sort((a, b) => a.sort - b.sort)
    }
  },
  mounted() {
    this.$api
    .get("/api/v1/videos")
    .then(response => {
      this.videos = response.data;
    })
    .catch(() => {});
  }
}
</script>

